"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function pauseObservability() {
    if (!window.puiFaro) {
        throw new Error("Faro instance is not initialized. Please call initObservability before calling pauseObservability.");
    }
    window.puiFaro.pause();
}
exports.default = pauseObservability;
//# sourceMappingURL=pauseObservability.js.map